import React, {FC} from "react"
import {TabContainer, TabButton} from "./styled"

interface ButtonProps {
  id: string,
  title: React.ReactElement
}

interface Props {
  buttons: ButtonProps[],
  onClick: (id: string) => void,
  selected: string
}

const ButtonTabs: FC<Props> = ({buttons, onClick, selected}) => (
  <TabContainer>
    {buttons.map((button) => {
      const {id, title} = button
      return (
        <TabButton key={id} id={id} active={selected === id} onClick={() => onClick(id)}>
          {title}
        </TabButton>
      )}
    )}
  </TabContainer>
)


export default ButtonTabs
